import { createContext } from "react"

export const SeriesVisibilityContext = createContext<
  ((key: string) => void) | null
>(null)
